<template>
  <div class="item">
    <div v-if="hasYoutubeUrl" class="video-container">
      <iframe :src="youtubeUrl"
              frameborder="0"
              allowfullscreen></iframe>
    </div>

    <img v-else :src="pathImage" alt="" class="img-thumbnail" />
    <div class="description">{{ description }}</div>
    <div v-show="!hasYoutubeUrl" class="icon">
      <a :href="pathSee" class="see cursor-pointer" target="_blank">
        <i class="fa fa-eye"></i></a>
      <a class="download cursor-pointer" @click="downloadFile(fileName)">
        <img :src="iconDownload" alt="" /></a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CommunicationItem',
    props: ['pathImage', 'pathSee', 'fileName', 'description', 'youtubeUrl'],
    computed: {
      iconDownload() {
        return require('@/assets/img/pages/icons/icons8-downloading-updates-60.png')
      },

      hasYoutubeUrl() {
        return this.youtubeUrl !== undefined;
      }
    },
    methods: {
      downloadFile(fileName) {
        const url = "/static/files/" + fileName;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/userKit/CommunicationItem.vue